import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TableLink = ({ title, url, icon, disabled, returnTo }) => {
  const [pathname, search] = url.split('?');

  return (
    <span title={title}>
      <Link
        to={{
          pathname: `${pathname}`,
          search: search ? `?${search}` : '',
          state: {returnTo},
        }}
        className={`table-link ${disabled ? 'disabled disabled-link' : ''}`}
      >
        <FontAwesomeIcon icon={icon} />
      </Link>
    </span>
  )
};

TableLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  returnTo: PropTypes.string,
};

TableLink.defaultProps = {
  url: '/',
  disabled: false,
  returnTo: undefined,
};

export default TableLink;
